import { Component } from 'react';
import './About.css';

class About extends Component {
  render() {
    const skills = ["Python", "SQL", "Git", "Linux", "Docker", "Pandas", "NumPy", "scikit-learn", "PyTorch"];            
  
    return (
      
      <div className="about-section">
        <h2 className="about-title">About Me</h2>

          <div className="about-content">

            <div className="about-photo">
              <div className="photo-placeholder">Your Photo</div>
            </div>

            <div className="about-info">

              <p className="about-description">
                Hello! I'm Abhisri, a passionate data science student at NJIT with 
                a strong interest in machine learning, AI, and robotics. I have experience in Python, Java, C++, 
                and various data science tools and frameworks. 
              </p>
                
              <p className="about-description"> 
                I'm eager to apply my skills to real-world problems and contribute to innovative projects in the field of data science and AI.
              </p>

              <div className="about-skills">
                <div className="skills-title">Skills & Technologies</div>
                <div className="skills-pills">
                  {skills.map((skill) => (
                    <span key={skill} className="skill-pill">{skill}</span>
                  ))}
                </div>
              </div>

            </div>

          </div>

      </div>

      
    );
  }
}

export default About;